import React from "react";
import { useSelector } from "react-redux";
import ItemProduct from "../../Common/ItemProduct";
import Order from "../../Common/Order";
import Payment from "../../Common/Payment";
import UserBuyer from "../../Common/UserBuyer";
import ContractTimes from "../../Common/ContractTimes";

const Index = ({ data, role,updateAll, setUpdateAll,isAbsent,appModal }) => {
  const { user } = useSelector(state => state);

  if (role) {
    return (
      <div>
        <ItemProduct details={{ item_name: data.product.item_name }} />
        <Order order={data.order} />
        <Payment payment={data.peyment} />
        <ContractTimes times={data.times} order={data.order} />
      </div>
    );
  }
  return (
    <div>
      
      {user.role != "manager" ? (
        <ItemProduct details={{ item_name: data.product.item_name }} />
      ) : (
        <></>
      )}
      <Order order={data.order} />
      <Payment payment={data.peyment} />
      {user.role != "user" ? <UserBuyer userbuyer={data.user_buyer} /> : <></>}
      <ContractTimes isAbsent={isAbsent} appModal={appModal} order={data.order} times={data.product.contract_product} role={user.role} updateAll={updateAll} setUpdateAll={setUpdateAll}/>
    </div>
  );
};

export default Index;
